import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useProject from '@hooks/useProject';
import { ProjectModel, Employee } from '@models/Models';
import { Container, Row, Col } from 'react-bootstrap';
import useEmployee from '@hooks/useEmployee';
import EmployeeComp from './components/EmployeeComp';
import MyButton from '@components/MyButton';

const PickEmployee = () => {
    const navi = useNavigate();
    const { projectId } = useParams();
    const { getProjectByID, updateProject } = useProject();
    const { getAllEmployees } = useEmployee();

    const [projectData, setProjectData] = useState<ProjectModel | null>(null);
    const [employeeTeam, setEmployeeTeam] = useState<Employee[]>([]);
    const [selectedTeam, setSelectedTeam] = useState<string[]>([]);

    useEffect(() => {
        if (projectId) {
            (async () => {
                const project = await getProjectByID(projectId as string);
                if (project.success) {
                    setProjectData(project.data as ProjectModel);
                    setSelectedTeam(project.data.employeeTeam); // Set selected team
                } else {
                    console.error('Failed to fetch project:', project.message);
                    alert(project.message);
                }

                const employees = await getAllEmployees();
                if (employees.success) {
                    setEmployeeTeam(employees.data as Employee[]);
                } else {
                    console.error('Failed to fetch employees:', employees.message);
                    alert(employees.message);
                }
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectId]);

    const addEmployeeToTeam = (employeeId: string) => {
        if (!selectedTeam.includes(employeeId)) {
            setSelectedTeam(prevState => [...prevState, employeeId]);
        }
    };

    const removeEmployeeFromTeam = (employeeId: string) => {
        setSelectedTeam(prevState => prevState.filter(emp => emp !== employeeId));
    };

    const handleSave = async () => {
        const updateResponse = await updateProject(projectId as string, { employeeTeam: selectedTeam });

        if (!updateResponse.success) {
            console.error('Failed to update project:', updateResponse.message);
            alert(updateResponse.message);
            return;
        }

        navi("/");
    };

    return (
        <Container className='myCont'>
            <Row>
                <h1>Projekt Mitarbeiter Aktivierung/Deaktivierung</h1>
                <h3>Project Name: <strong className='text-decoration-underline'>{projectData?.name}</strong></h3>
                <span>Nur der ausgewählte Mitarbeiter kann dieses Projekt sehen.</span>
                <Col className='my-5'>
                    {employeeTeam.map((employee) => (
                        <EmployeeComp
                            key={employee.id}
                            item={employee}
                            selectedTeam={selectedTeam}
                            onRemove={removeEmployeeFromTeam}
                            onAdd={addEmployeeToTeam}
                        />
                    ))}
                </Col>
            </Row>
            <Row>
                <Col>
                    <MyButton
                        title='Speichern'
                        isSecundary={false}
                        disabled={false}
                        onClick={handleSave}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default PickEmployee;
